import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { ImageWider } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'

export const UNIVERSAL_CPC_NATIVE: IProductDefinition = {
  productTypeId: 'UNIVERSAL_CPC_NATIVE',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/universal-cpc-native/',
  title: 'campaign:displayCPCNative.title',
  titleForAdmin: 'Display CPC Native',
  budget: {
    model: 'CPC',
    type: 'TOTAL',
    variant: 'ANY',
    validation: {
      globalLimit: {
        min: limits.MINIMUM_BUDGET,
      },
      dailyLimit: {
        min: limits.MINIMUM_DAILY_BUDGET,
      },
      rate: {
        min: 0.3,
      },
    },
  },
  campaignHowToWorks: 'campaign:displayCPCNative.howDisplayCPCWorks',
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  campaignWPBoosterRequirements: ['smartTargeting', 'pixel', 'creations'],
  allowedCreationTypes: ['NATIVE'],
  creationsDescription: {
    description: 'wizard:displayCPCNativeRequiredMaterials',
  },
  targeting: {
    countries: true,
    demography: true,
    devices: true,
    emitToTrusted: true,
    locations: true,
    smartTargeting: true,
    optimizationMetric: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.NATIVE,
    productDescription: {
      title: `${lng('wizard:displayCPCNativeTitle')} - natywne api`,
      description: lng('wizard:displayCPCNativeDescription'),
      Icon: ImageWider,
      wpBooster: true,
    },
    parameters: [
      {
        label: lng('campaign:format'),
        value: lng('campaign:banner'),
      },
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.cpc'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('campaign:trafficAcquisition'),
      },
      {
        label: lng('wizard:requiredMaterials'),
        value: lng('wizard:displayCPCNativeRequiredMaterials'),
      },
      {
        label: lng('campaign:wpBooster'),
        value: lng('campaign:wpBoosterAIDescription'),
      },
    ],
  },
}
